<template>
    <div class="record-wrapper">
        <div v-if="loaded">
            <div v-if="list.length" class="record-list">
                <div class="list-item" v-for="(item, index) in list" :key="index">
                    <div class="flex1">
                        <div class="name">奖品名称: {{ item.name }}</div>
                        <div class="time">中奖时间: {{ item.luckTime }}</div>
                        <div class="code" v-if="item.code">中奖码: {{ item.code }}</div>
                    </div>
                    <div class="address" v-if="item.state == 1" @click="showInfoClick(item)"><img src="../img/icon1.png" />
                    </div>
                </div>
            </div>
            <div v-else class="list-none">
                暂无记录
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import COVERAPP from '@/utils/COVERAPP'
import COVER from '@/utils/COVER'
import Moment from 'moment'

export default {
    computed: {
        ...mapState(['userInfo', 'aid', 'activityData', 'shareData'])
    },
    data() {
        return {
            isApp: false,
            list: [],
            showInfoModal: false,
            modalData: {},
            showRandomModal: false,
            loaded: false,
        }
    },
    created() {
        COVER.getUser((res) => {
            if (res && res.token) {
                this.SET_USERINFO(res);
                this.getList();
            }
        })
    },
    mounted() {
        this.isApp = COVERAPP.Attribute.isApp()

        setTimeout(() => {
            this.SET_PAGELOADING(false);
        }, 500)
        COVER.track(this.aid, 'load', '进入我的奖品页')
    },
    methods: {
        ...mapMutations(["SET_DIALOGDATA", "SET_PAGELOADING", "SET_USERINFO"]),
        closeInfo() {
            this.showInfoModal = false
        },
        showInfoClick(item) {
            const btns = [
                {
                    text: '提交',
                    className: 'info-btn',
                    callback: (info) => {
                        this.submitInfo(info, item.pid)
                    }
                }, {
                    text: '确定',
                }, {
                    text: '提现',
                }
            ]
            this.SET_DIALOGDATA({
                message: `恭喜您获得${item.name}`,
                field: this.activityData.templateConfig.field,
                btns: [
                    this.activityData.templateConfig.field && this.activityData.templateConfig.field.length
                        ? btns[0] : btns[1]
                ],
                showClose: true,
            })
        },
        submitInfo(info, pid) {
            // this.setToastData('提交中')
            COVER.$post('/lottery/prize/info', {
                pid: pid,
                info: info,
                aid: this.aid,
                userinfo: this.userInfo
            }, 'post').then((data) => {
                if (data.errno === 0) {
                    // this.setToastData(null)
                    this.SET_DIALOGDATA({
                        message: '您的兑奖联系方式已提交成功。',
                        btns: [
                            {
                                text: '确定'
                            }
                        ]
                    })
                    this.getList();
                } else {
                    let err = data;
                    this.SET_DIALOGDATA({
                        message: err && err.errmsg || '出错了',
                        btns: [
                            {
                                text: '确定'
                            }
                        ]
                    })
                }
            })
        },
        getList() {
            // this.$toast.loading('加载中')
            this.loaded = false
            COVER.$post('/lottery/prize/list', {
                aid: this.aid,
                userinfo: this.userInfo,
            }, 'post').then(({ data, errno }) => {
                if (errno === 0) {
                    // this.$toast.clear()
                    this.list = data.list.filter((v) => v.type !== 'none').map((v) => {
                        return {
                            ...v,
                            time: Moment(v.luckTime).format('YYYY.MM.DD'),
                            amount: v.amount ? (v.amount / 100).toFixed(2) : 0
                        }
                    });
                    this.loaded = true
                } else {
                    this.loaded = true
                    // this.$toast(err.errmsg || '出错了')
                }
            })
        },
    }
}
</script>

<style>
.record-wrapper {
    width: 100vw;
    height: 100vh;
    position: relative;
    overflow: auto;
    background: url(../img/bg.jpg) no-repeat;
    background-size: 100% 100%;
}

.record-wrapper .empty {
    color: #fcefc9;
    font-size: 3vw;
    width: 100%;
    text-align: center;
    padding: 8vw 0 5vw;
}

.record-wrapper .empty img {
    width: 46.296vw;
    min-height: 8.796vw;
    margin: 8vw auto;
}

.record-wrapper .list-none {
    line-height: 5;
    text-align: center;
    color: #fff;
    font-size: 5vw;
}

.record-wrapper .record-wrapper.title {
    width: 36.111vw;
    height: 8.796vw;
    margin: 6.481vw auto 5vw;
}

.record-wrapper .record-list {
    width: 100%;
    padding: 12vw;
    overflow: hidden;
    font-size: 4vw;
    color: #fff;
}

.record-wrapper .record-list .name {
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    line-height: 1.4;
}

.record-wrapper .record-list .address {
    width: 12vw;
    height: 12vw;
}

.record-wrapper .record-list .list-header {
    display: flex;
    align-items: center;
    font-weight: bold;
}

.record-wrapper .record-list .list-header div {
    flex: 1;
}

.record-wrapper .record-list .list-item {
    margin-bottom: 3vw;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid;
    padding-bottom: 3vw;
}

.record-wrapper .record-list .flex1 {
    flex: 1;
}
</style>
